import { POSITIONS, YES_NO_INVERSE, VALIDATIONS, MEMBER_ACCOMODATION_NEEDS } from '../../../../constants';
import { optionValues, radioOptionValues } from '../../../../utils/utils';
import SharedForm from '../../../../components/ui/Form';
const OutreachMemberNeeds = ({ data, onInputChange, onFormValidate }) => {
    const memberNeedsArr = [
        {
            key: 'needTransportation',
            labelName: 'Need Transportation',
            type: 'radio',
            optionValues: radioOptionValues(YES_NO_INVERSE, true),
            required: false,
        },
        {
            key: "transportationNeeds",
            placeholderName: "Provide any additional details about your transportation needs.",
            labelName: '',
            type: "textarea",
            required: false,
            maxLength: 255,
            hidden: !(data.needTransportation && data.needTransportation === YES_NO_INVERSE.Yes),
            valid: VALIDATIONS.String.noSpecialChars,
            charCounter: true
        },
        {
            key: 'specificAccommodation',
            labelName: 'Specific Accommodation',
            type: 'radio',
            optionValues: radioOptionValues(YES_NO_INVERSE, true),
            required: false,
        },
        {
            key: "specificAccommodationNeeds",
            labelName: '',
            type: "options",
            optionValues: optionValues(MEMBER_ACCOMODATION_NEEDS, true),
            required: false,
            maxLength: 50,
            hidden: !(data.specificAccommodation && data.specificAccommodation === YES_NO_INVERSE.Yes),
        },
        {
            key: "specifyOtherAccommodation",
            placeholderName: "Specify Other Accommodation",
            labelName: '',
            type: "text",
            required: false,
            maxLength: 50,
            hidden: !(
                data.specificAccommodation === YES_NO_INVERSE.Yes &&
                data.specificAccommodationNeeds === MEMBER_ACCOMODATION_NEEDS.Other
            ),
            charCounter: true,
            valid: VALIDATIONS.String.noSpecialChars,
        },
        {
            key: 'dietaryRestrictionsAccommodation',
            labelName: 'Dietary Restrictions',
            placeholderName: 'Dietary Restrictions',
            type: 'radio',
            optionValues: radioOptionValues(YES_NO_INVERSE, true),
            required: false,
        },
        {
            key: "dietaryRestrictionsNeeds",
            placeholderName: "Specify Dietary Needs",
            labelName: '',
            type: "text",
            required: false,
            maxLength: 50,
            hidden: !(data.dietaryRestrictionsAccommodation && data.dietaryRestrictionsAccommodation === YES_NO_INVERSE.Yes),
            valid: VALIDATIONS.String.noSpecialChars,
            charCounter: true
        },
    ]

    return (
        <div className="px-xl-2 py-xl-2">
            <SharedForm
                cols={12}
                array={memberNeedsArr}
                modelObj={data}
                onInputChanged={onInputChange}
                onFormValidate={onFormValidate}
                actionBarPosition={POSITIONS.NONE}
            />
        </div>
    )
}

export default OutreachMemberNeeds;
